<template>
  <a-modal
    :visible="visible"
    title="裁剪图片"
    :maskClosable="false"
    :confirmLoading="confirmLoading"
    :width="500"
    @cancel="cancelHandel"
  >
    <div class="cropper-wrapper">
      <vue-cropper
        ref="cropper"
        :img="options.img"
        :info="true"
        :original="true"
        :fixed="true"
        :autoCrop="options.autoCrop"
        :autoCropWidth="options.autoCropWidth"
        :autoCropHeight="options.autoCropHeight"
        :fixedBox="options.fixedBox"
        :canMoveBox=" options.canMoveBox"
        :fixedNumber="options.fixedNumber"
        :outputSize="options.outputSize"
        :infoTrue="true"
        @realTime="realTime"
      >
      </vue-cropper>
    </div>
    <!-- <div class="result-wrapper">
      <div class="tar-img" :style="previews.div">
        <img :src="previews.url" :style="previews.img"/>
      </div>
    </div> -->
    <template slot="footer">
      <a-button key="back" @click="cancelHandel">取消</a-button>
      <a-button key="submit" type="primary" :loading="confirmLoading" @click="okHandel">保存</a-button>
    </template>
  </a-modal>
</template>
<script>
import { VueCropper } from 'vue-cropper'

export default {
  name: 'cropperModal',
  components: {
    VueCropper
  },
  data () {
    return {
      visible: false,
      img: null,
      confirmLoading: false,
      fileName: '',
      options: {
        img: '', // 裁剪图片的地址
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 400, // 默认生成截图框宽度
        autoCropHeight: 400, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false,
        fixedNumber: [1, 1],
        outputSize: 1
      },
      previews: {}
    }
  },
  methods: {
    edit (record) {
      let { options } = this
      this.visible = true
      this.options = Object.assign({}, options, record)
      this.fileName = record.fileName
    },
    cancelHandel () {
      this.options = {
        img: '/avatar2.jpg',
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 400, // 默认生成截图框宽度
        autoCropHeight: 400, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小 不允许改变
        canMoveBox: false,
        fixedNumber: [1, 1],
        outputSize: 1
      }
      this.visible = false
      this.$emit('cancel')
    },
    okHandel () {
      const that = this
      that.confirmLoading = true
      // 获取截图的base64 数据
      this.$refs.cropper.getCropData((data) => {
        // 转换为File对象
        let file = this.dataURLtoFile(data, this.fileName)
        // 将裁剪侯的图片对象返回给父组件
        that.$emit('ok', file)
        that.confirmLoading = false
        this.visible = false
      })
    },
    // 下载输入框里的图片
    downloadNewImg () {
      // 获取截图的blob数据
      this.$refs.cropper.getCropBlob((data) => {
        console.log(data)
      })
    },
    // 移动框的事件
    realTime (data) {
      this.previews = data
    },
    // 将base64转换为文件
    dataURLtoFile (dataurl, filename) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    /**
       * dataURL 转成 blob
       * @param dataURL
       * @return blob
       */
    dataURL2blob (dataURL) {
      let binaryString = atob(dataURL.split(',')[1])
      let arrayBuffer = new ArrayBuffer(binaryString.length)
      let intArray = new Uint8Array(arrayBuffer)
      let mime = dataURL.split(',')[0].match(/:(.*?);/)[1]
      for (let i = 0, j = binaryString.length; i < j; i++) {
        intArray[i] = binaryString.charCodeAt(i)
      }
      let data = [intArray]
      let result
      try {
        result = new Blob(data, { type: mime })
      } catch (error) {
        let BlobBuilder = window.BlobBuilder ||
            window.WebKitBlobBuilder ||
            window.MozBlobBuilder ||
            window.MSBlobBuilder
        if (error.name === 'TypeError' && window.BlobBuilder) {
          let builder = new BlobBuilder()
          builder.append(arrayBuffer)
          result = builder.getBlob(mime)
        } else {
          throw new Error('处理失败')
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
  .cropper-wrapper{
    width: 400px;
    height: 400px;
    margin: 0 auto;
  }
  .result-wrapper{
    margin-top: 20px;
    width: 100%;
    display: flex;
    padding: 20px;
    justify-content: center;
    .tar-img{
      overflow: hidden;
    }
  }

</style>
